<!-- 繳交文件設定 -->
<template>
	<div style="display: flex">
		<Step :workflow="workflow" @goForm="goForm"></Step>
		<div class="step-form" v-if="$route.meta.formKeepAlive">
			<ListForm
				api="coopLoanProjectDoc"
				:id="id"
				labelPosition="top"
				formTitle="理事會同意紀錄"
				:rules="rules"
				:recordToEdit="recordToEdit"
				:formType="formType"
				@changeIou="changeIou"
				@viewRcd="viewRcd"
				ref="list"
			>
				<div slot="formSlot">
					<p v-if="hasIouModifyBefore" style="color: red;">
						<span style="font-weight: bold;">重要注意事項:</span><br>

						1.若該筆借款目前仍有生效履約中之借款條件異動申請，如仍要新增借款條件異動申請且生效，日後若發生新增借款條件異動申請違約時，原借款條件異動申請如有減收利息或違約金部分，系統將無法再回復(收回)已減收利息或違約金，請務必確認後再執行新增借款條件異動申請，或取消本次申請。<br>

						2.借款條件異動設定完成後，<span style="font-weight: bold; text-decoration: underline;">須於隔日才會生效。</span><br>

						3.辦理【借款條件異動處理】僅可適用不同放款方案（亦即適用新方案借款利率），或減免前欠利息及違約金，<span style="font-weight: bold; text-decoration: underline; font-size: 18px;">無法調整該借款之借款期間、欠付本金逾期等情形</span>，如有還款困難、欠付本金無法清償逾期以致違約或已逾最後借款期限到期者，仍需接續辦理<span style="font-size: 18px;">【分期協議償還】</span>方能繼續依分期約定償還。或是辦理其他申請，如:呆帳轉銷、換單(如已取得債權確定相關文件，應禁止辦理換單)申請。<br>

						4.失效情形:如辦理【借款條件異動處理】後如下列違約情形或是未辦理其他申請，將會使【借款條件異動處理】失效，並將原減免之前欠利息及違約金金額回復至原借款欠付款項。<br>

						(1)未能依新放款方案償還；<br>

						(2)未辦理分期協議償還或是換單；<br>

						(3)已辦理分期協議償還或是換單，但未依約償還導致違約失效。
					</p>
				</div>
				<div slot="footer">
					<el-button
						type="primary"
						v-if="recordToEdit.iouModifyStatus == 1"
						@click="submitRcd()"
						>送出</el-button
					>

					<el-button @click="$refs.list.back()">關閉</el-button>
				</div>

				

			</ListForm>
			<el-dialog
				:title="dialogTitle"
				:visible.sync="dialogEdit"
				append-to-body
				:show-close="false"
				class="modal-show"
			>
				<ListForm
					v-if="dialogType == 'viewRcd'"
					api
					:id="id"
					labelPosition="top"
					:rules="rules"
					:recordToEdit="meetingRcd[recordToEdit.meetingRcdId]"
					:formType="meetingRcdFormType"
				>
					<div slot="footer">
						<el-button type="primary" @click="downLoanMeetingRcd">下載會議記錄</el-button>
						<el-button @click="dialogEdit = false">關閉</el-button>
					</div>
				</ListForm>
				<workbench
					v-else
					api="coopLoanIou"
					:columns="columnsIou"
					:toolbar="toolbarIou"
					:query="query"
					@editData="chooseIou"
				></workbench>
			</el-dialog>
		</div>
		<div class="step-form" v-else>
			<router-view
				:actvie="active"
				:workflow="workflow"
				:titleLabel="titleLabel"
				:parentRecord="recordToEdit"
				:enumData="enumData"
				@reflashWorkFlow="getData"
			></router-view>
		</div>
	</div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";
import Step from "@/components/Step.vue";

export default {
	name: "loan_plan_change_edit",
	components: {
		ListForm,
		Workbench,
		Step,
	},
	props: {},
	data() {
		return {
			isFirstTime:
				this.$route.query.isFirstTime != null
					? this.$route.query.isFirstTime
					: true,
			hasIouModifyBefore:false,
			active: 0,
			titleLabel: "",
			dialogTitle: "",
			dialogEdit: false,
			dialogType: "chooseIou",
			id: this.$route.params.id == "new" ? 0 : this.$route.params.id,
			recordToEdit: {},
			toolbarIou: { addable: false, removeable: false, select: false },
			query: {
				action: "getRunningIou",
			},
			workflow: [],
			enumData: {},
			meetingRcd: {},
			formPathList: {
				理事會同意紀錄: "loan_plan_change_edit",
				設定新方案與減免: "loan_plan_change_project",
				主任審查: "loan_plan_change_review_director",
				經理審查: "loan_plan_change_review_manager",
				理事會審查: "loan_plan_change_review_council",
				督導審查: "loan_plan_change_review_supervision",
				督導組長審查: "loan_plan_change_project_supervision_manager",
				儲互社確認: "loan_plan_change_coop_recheck",
			},
			meetingRcdFormType: [
				{
					label: "會議日期",
					key: "meetingDate",
					type: "date",
					disabled: true,
				},
				{
					label: "會議記錄名稱",
					key: "name",
					type: "input",
					disabled: true,
				},
				{
					label: "分類",
					key: "typeKey",
					type: "select",
					options: [],
					disabled: true,
				},
				{
					type: "input",
					key: "typeOther",
					disabled: true,
				},
				{
					label: "備註",
					key: "note",
					type: "textarea",
					disabled: true,
				},
			],
			columnsIou: [
				{
					prop: "iouNumber",
					label: "借據號碼",
				},
				{
					prop: "",
					label: "社員帳號",
					renderFunction(h, scope) {
						return h(
							"div",
							`${
								scope.row.memberAccount
									? scope.row.memberAccount
									: ""
							} ${
								scope.row.memberName ? scope.row.memberName : ""
							}`
						);
					},
				},
				{
					prop: "memberName",
					label: "社員名稱",
				},
				{
					prop: "iouDateStart",
					label: "借款期間(起)",
					renderFunction(h, scope) {
						return h(
							"div",
							scope.row.iouDateStart
								? scope.row.iouDateStart.split(" ")[0]
								: ""
						);
					},
				},
				{
					prop: "iouDateEnd",
					label: "借款期間(迄)",
					renderFunction(h, scope) {
						return h(
							"div",
							scope.row.iouDateEnd
								? scope.row.iouDateEnd.split(" ")[0]
								: ""
						);
					},
				},
			],

			formType: [
				{
					label: "審查日期",
					key: "meetingRcdReviewDate",
					type: "date",
				},
				{
					label: "理事會會議紀錄",
					key: "meetingRcdId",
					type: "select",
					options: [],
				},
				{
					button: "檢視",
					type: "button",
					buttonType: "primary",
					buttonKey: "viewRcd",
				},
				{
					label: "借據編號",
					key: "iouNumber",
					type: "input",
					disabled: true,
				},
				{
					button: "變更借據",
					type: "button",
					buttonType: "primary",
					buttonKey: "changeIou",
					vif: true,
				},
				{
					type: "slot",
					slot: "formSlot",
				}
			],
			rules: {
				name: [
					{ required: true, message: "請輸入姓名", trigger: "blur" },
				],
			},
		};
	},
	created() {
		this.getData();
	},
	watch:{
		'recordToEdit.iouNumber':function(){
			this.checkOldIouModify(this.recordToEdit.iouNumber);
		}
	},
	methods: {
		downLoanMeetingRcd() {
            let url =
                API.coopLoanIouModify +
                `?action=downloadForm&id=${this.recordToEdit.meetingRcdId}`;
            this.mDownloadFile(url);
        },
		submitRcd() {
			let url = API.coopLoanIouModify + "?action=submitRcd";

			let meetingRcdReviewDate = this.$toGeneralDate($(".meetingRcdReviewDate").val());
			let dataPost = new FormData();
			dataPost.append("id", this.recordToEdit.id);
			dataPost.append("iouNumber", this.recordToEdit.iouNumber);
			dataPost.append("memberId", this.recordToEdit.memberId);
			dataPost.append("meetingRcdId", this.recordToEdit.meetingRcdId);
			dataPost.append("meetingRcdReviewDate", meetingRcdReviewDate);
			const postCB = (json) => {
				this.showAjaxSuccessMsg();
				this.getData();
				this.$router.push({
					name: "loan_plan_change_project",
				});
			};
			this.mAxiosPost(url, dataPost, postCB);
		},
		changeIou() {
			this.dialogType = "chooseIou";
			this.dialogTitle = "選擇借據";
			this.dialogEdit = true;
		},
		viewRcd() {
			if (!this.recordToEdit.meetingRcdId) {
				this.$message.closeAll();
				this.$message({
					type: "error",
					message: "尚未選擇理事會紀錄",
				});
				return;
			}
			this.dialogType = "viewRcd";
			this.dialogTitle = "檢視理事會紀錄";
			this.dialogEdit = true;
		},
		chooseIou(data, row) {
			this.recordToEdit.iouNumber = row.iouNumber;
			this.recordToEdit.memberId = row.memberId;
			this.dialogEdit = false;
		},
		checkOldIouModify(iouNumber){

			let url = API.coopLoanIouModify + `?action=checkOldIouModify&iouNumber=${iouNumber}`;

			const thenCB = (json) => {
				
				this.hasIouModifyBefore = json.resultData.hasIouModifyBefore;
			};

			this.mAxiosGet(url, thenCB);
		},
		getData(isAutoForward = false) {
			const url = API.coopLoanIouModify + `?id=${this.id}`;

			const thenCB = (json) => {
				this.recordToEdit = Object.assign(
					{},
					this.recordToEdit,
					json.resultData.data
				);

				let enu = json.resultData.enumData;
				// 一併存起來傳給子頁 (Project / CoopRecheck)，避免子頁重複打同一支 API
				this.enumData = enu;

				enu.meetingRcd.forEach((item) => {
					this.meetingRcd[item.id] = item;
				});

				this.hasIouModifyBefore = enu.hasIouModifyBefore;
				this.meetingRcdFormType[2].options =
					json.resultData.enumData.typeKey;

				this.formType[4].vif = this.recordToEdit.iouModifyStatus == 1;
				this.formType[1].options = enu.meetingRcd;
				this.workflow = this.bindWorkFlow(enu.workFlow);

				// 自動前往目前流程頁面
				this.aufoForward(isAutoForward);
			};
			this.mAxiosGet(url, thenCB);
		},
		aufoForward(isAutoForward) {
			if (this.isFirstTime == true || isAutoForward) {
				let flowSearch = this.workflow.filter(
					(flow) =>
						(flow.type == 1 && flow.status == 1) ||
						(flow.type == 2 && flow.status == 1)
				)[0];
				this.goForm(flowSearch);

				this.isFirstTime = false;
			}
		},
		bindWorkFlow(workFlow) {
			return workFlow.map((flow) => {
				flow["name"] = this.formPathList[flow.label]
					? this.formPathList[flow.label]
					: "";
				return flow;
			});
		},
		goForm(item, index) {
			this.$router.push({
				name: `${item.name}`,
				params: {
					id: this.id,
				},
			});
		},
	},
};
</script>
